import dayjs from 'dayjs';

const MINUTES_THRESHOLD = 15;

function has15MinutesPassed(startDateStr: string, endDate: Date): boolean {
  const startDate = dayjs(startDateStr);
  const end = dayjs(endDate);

  return end.diff(startDate, 'minute') >= MINUTES_THRESHOLD;
}

export default has15MinutesPassed;
